export default __webpack_public_path__ + "static/media/helium-dog.0581d863.jpeg";